// components/notifications/notificationSelectors.ts
import type { KernelState, NotificationDTO } from '#types/types';

/**
 * Notifications actives : celles du compte courant, non lues et non archivées.
 * Unique définition partagée par la cloche (compteur) et le centre (liste), pour
 * qu'un changement de la règle de visibilité ne puisse pas les désynchroniser.
 */
export const selectVisibleNotifications = (state: KernelState): NotificationDTO[] => {
  const currentUserId = state.userContext.dbUserId ?? null;
  if (!currentUserId) return [];
  return Object.values(state.inventory.Notification.registry)
    .filter((notification): notification is NotificationDTO => {
      if (!notification) return false;
      if (notification.userId !== currentUserId) return false;
      return !notification.readAt && !notification.archivedAt;
    });
};

/** What the centre lists: the account's notifications not removed, read or not. */
export const selectRecentNotifications = (state: KernelState): NotificationDTO[] => {
  const currentUserId = state.userContext.dbUserId ?? null;
  if (!currentUserId) return [];
  return Object.values(state.inventory.Notification.registry)
    .filter((notification): notification is NotificationDTO => Boolean(notification) && notification!.userId === currentUserId && !notification!.archivedAt);
};

export const notificationToastId = (userId: string, id: string) => `notification:${userId}:${id}`;
